import api from '@/services/api';
import { make } from 'vuex-pathify';

const state = {
  offers: [],
};

const mutations = {
  ...make.mutations(state),
};

const actions = {
  async createOffer({ dispatch }, offer) {
    await api.post('v2/offers/projects', offer);
    await dispatch('getOffers');
  },
  async editOffer({ dispatch }, { id, payload }) {
    await api.put(`v2/offers/projects/${id}`, payload);
    await dispatch('getOffers');
  },
  async getOffers({ commit }) {
    const r = await api.get('v2/offers/projects');
    commit('SET_OFFERS', r.data.data?.projects || []);
  },
  async deleteOffer({ dispatch }, { id }) {
    await api.delete(`v2/offers/projects/${id}`);
    await dispatch('getOffers');
  },
  async createProject({ dispatch }, { offerId, payload }) {
    await api.post(`v2/offers/projects/${offerId}/layers`, payload);
    await dispatch('getOffers');
  },
  async deleteProject({ dispatch }, { id, offerId }) {
    await api.delete(`v2/offers/projects/${offerId}/layers/${id}`);
    await dispatch('getOffers');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
